import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ab2eab34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Login" }
const _hoisted_2 = { class: "Login_Container" }
const _hoisted_3 = { class: "Login_Wrapper" }
const _hoisted_4 = { class: "Login_Form" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Login_Form_Title" }, "仮パスワード発行", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" パスワードを忘れた方は、登録されているメールアドレスを入力してください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("仮パスワードを記載したメールを送信します。 ")
], -1))
const _hoisted_7 = { class: "error_message" }

import { reactive, ref } from "vue";
import { useStore } from "vuex";
import { Notyf } from "notyf";
import { useRouter } from "vue-router";
import axios from "axios";
import BtnGreen from "../components/atoms/button/BtnGreen.vue";
import InputText from "../components/atoms/Input/InputText.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordForget',
  emits: ["toggleGlobalHeader"],
  setup(__props, { emit: __emit }) {

const $router = useRouter();
const emit = __emit;
const store = useStore();
const notyf = new Notyf();

emit("toggleGlobalHeader");

const setBaseUrl = () => {
  store.commit("setBaseUrl");
};
setBaseUrl();

//ログイン--------------------------------------
const sendEmail = async () => {
  validateError();
  if (hasError.value === false) {
    try {
      const res = await axios.post(
        `${store.getters["getBaseUrl"]}/account/resetPassword?email=${mailAddress.value}`,
        "",
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      if (res.data === "OK") {
        notyf.success("メールを送信しました");
        $router.push("/passwordMailSubmitted");
        mailAddress.value = "";
      } else {
        notyf.error(res.data);
      }
    } catch (error) {
      alert("メールの送信に失敗しました");
      console.log(error);
    }
  }
};

let mailAddress = ref("");
const mailInput = (e: string) => {
  mailAddress.value = e;
};

let hasError = ref(false);
let errorMessage = reactive({
  email: "",
  password: "",
});
const validateError = () => {
  hasError.value = false;
  errorMessage.email = "";
  errorMessage.password = "";
  if (mailAddress.value === "") {
    errorMessage.email = "メールアドレスを入力してください";
    hasError.value = true;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createVNode(InputText, {
            class: "Login_Form_Input",
            placeholder: "メールアドレス",
            value: _unref(mailAddress),
            onOnInput: mailInput
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(errorMessage).email), 1),
          _createVNode(BtnGreen, {
            class: "Login_Form_BtnGreen",
            onClick: sendEmail
          }, {
            default: _withCtx(() => [
              _createTextVNode("送信")
            ]),
            _: 1
          }),
          _createElementVNode("p", null, [
            _createElementVNode("a", null, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _createTextVNode("ログイン画面に戻る")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})